"use client";

import { useProductTileClickImpressions } from "@faire/deprecated-retailer-visitor-shared/hooks/ProductTileImpression/useProductTileClickImpressions";
import { useProductTileViewImpression } from "@faire/deprecated-retailer-visitor-shared/hooks/ProductTileImpression/useProductTileViewImpression";
import { assignSettingOnEvent } from "@faire/deprecated-retailer-visitor-shared/settings/assignSettingOnEvent";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import { useEffectEvent } from "@faire/web/ui/hooks/useEffectEvent";
import React from "react";

import { ProductTileContainerRefContextProvider } from "../../../ComposableProductTile/__internal__/__internal__/ProductTileContainerRefContextProvider";
import { ITrackingProps } from "../../types";

import { useTileInteractions } from "./TileInteractionsContextProvider";

export const ProductTileClientContainer = ({
  data: {
    productToken,
    isPromoted,
    impressionId,
    promotedBy,
    badgeList,
    bestImage,
    images,
    settingsToAssignOnView,
  },
  children,
}: {
  data: ITrackingProps;
  children: React.ReactNode;
}) => {
  const { tileActions } = useTileInteractions();
  const trackProductTileProps = useProductTileViewImpression({
    productToken,
    promotedBy,
    impressionId,
  });
  const {
    recordProductTileRightClickEvent,
    recordProductTileMiddleClickEvent,
  } = useProductTileClickImpressions(
    {
      token: productToken,
      isPromoted,
      impressionId,
      promotedBy,
      badgeList,
      bestImage,
      images,
    },
    ""
  );

  const settingAssignmentRef = useDoActionWhenVisible(() => {
    settingsToAssignOnView?.forEach((setting) => {
      assignSettingOnEvent(setting);
    });
  });

  const handleOnAuxClick = useEffectEvent(
    (event: React.MouseEvent<HTMLElement>) => {
      if (event.button === 1) {
        recordProductTileMiddleClickEvent();
      } else if (event.button === 2) {
        recordProductTileRightClickEvent();
      }
    }
  );
  return (
    <div
      {...trackProductTileProps}
      onAuxClick={handleOnAuxClick}
      onTouchStart={tileActions?.onTouchStart}
      onMouseEnter={tileActions?.onMouseEnter}
      onMouseLeave={tileActions?.onMouseLeave}
      ref={(element) => {
        settingAssignmentRef(element);
        trackProductTileProps?.ref?.(element);
      }}
    >
      <ProductTileContainerRefContextProvider>
        {children}
      </ProductTileContainerRefContextProvider>
    </div>
  );
};
